import { registerHubUsers } from '@/requests/preLogin/landing.api'
import { useMutation } from '@tanstack/react-query'

export const useHubRegistration = ({ handleOnSuccess, handleOnError }: IMutationParameters) => {
  const mutation = useMutation({
    mutationFn: registerHubUsers,
    onSuccess: (response) => {
      handleOnSuccess?.(response.data)
    },
    onError: (err) => {
      handleOnError?.(err)
    },
  })
  return {
    mutation,
  }
}
